import { render, staticRenderFns } from "./commit-data.vue?vue&type=template&id=9436c802&scoped=true"
import script from "./commit-data.vue?vue&type=script&lang=js"
export * from "./commit-data.vue?vue&type=script&lang=js"
import style0 from "./commit-data.vue?vue&type=style&index=0&id=9436c802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9436c802",
  null
  
)

export default component.exports